<template>
  <div>
    <!-- <general-top-bar :title="$t('reports.mixReport')"></general-top-bar> -->
    <div class="sales-report" style="margin-top: 20px;">
      <div class="row mar-bt-15">
        <div class="col-md-6" v-if="showLocations">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <option v-for="loc in locations" :key="'loc-' + loc.id" :label="loc.name" :value="loc.id">{{loc.name}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
        </div>
        <div class="pull-left" style="display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 10px;">
          {{$t('general.from')}}
          <el-time-select
            :placeholder="$t('catalogProd.timePlaceholder')"
            style="margin-left: 10px;"
            :value="valid_from"
            v-model="valid_from"
            :change="changeValidFrom()"
            class="mar-rt-5"
            :picker-options="{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }">
          </el-time-select>
          {{$t('general.to')}}
          <el-time-select
            :placeholder="$t('catalogProd.timePlaceholder')"
            :value="valid_to"
            v-model="valid_to"
            :change="changeValidFrom()"
            class="mar-lt-5"
            :picker-options="{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }">
          </el-time-select>
        </div>
        <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
        </div>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">{{ $t('reports.filteredData') }} <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:59</b></p>
      </div>

      <div class="col-md-12" v-if="ordersTableData.data && ordersTableData.data.length > 0">
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-content" v-loading="loading">
                <div class="report-container-compact">
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.orderCounter')}}</div>
                    <div class="report-col right-align">{{totalCounter}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="card-content total-pagination reports-center-columns mixed-report-table-wrapper">
            <div class="mixed-table-scroll-container">
              <data-tables-server
                @query-change="paginationChanged"
                v-loading="loading"
                :data="ordersTableData.data"
                :total="totalRecords"
                :search-def="{show: false}"
                :pagination-props="paginationProps"
                :table-props="tableOptions"
                class="report-sales mixed-report-table"
                key="mixed-report-table"
                style="width: 100%"
                ref="reportsTable">

              <!-- ID -->
              <el-table-column
                class-name="centered-cell"
                :min-width="80"
                :width="80"
                prop="id"
                :label="$t('reports.id')">
                <template slot-scope="props">
                  {{ props.row.id || '' }}
                </template>
              </el-table-column>

              <!-- Name / Category -->
              <el-table-column
                class-name="left-align-cell"
                :min-width="200"
                :width="200"
                prop="name"
                :label="$t('reports.productName')">
                <template slot-scope="props">
                  {{ props.row.name || '' }}
                </template>
              </el-table-column>

              <!-- Sold -->
              <el-table-column class-name="centered-cell" :min-width="80" prop="sold" :label="$t('reports.sold')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.sold) }}
                </template>
              </el-table-column>

              <!-- Eat-In -->
              <el-table-column class-name="centered-cell" :min-width="80" prop="eatIn" :label="$t('reports.eatIn')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.eatIn) }}
                </template>
              </el-table-column>

              <!-- TakeOut -->
              <el-table-column class-name="centered-cell" :min-width="80" prop="takeOut" :label="$t('reports.takeOut')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.takeOut) }}
                </template>
              </el-table-column>

              <!-- Delivery -->
              <el-table-column class-name="centered-cell" :min-width="80" prop="other" :label="$t('reports.shipping')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.other) }}
                </template>
              </el-table-column>

              <!-- Mixed -->
              <!-- <el-table-column class-name="centered-cell" :min-width="80" prop="mixed" :label="$t('reports.mixed')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.mixed) }}
                </template>
              </el-table-column> -->

              <!-- Employee -->
              <el-table-column class-name="centered-cell" :min-width="80" prop="employee" :label="$t('reports.employee')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.employee) }}
                </template>
              </el-table-column>

              <!-- Refund -->
              <el-table-column class-name="centered-cell" :min-width="80" prop="refund" :label="$t('reports.refund')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.refund) }}
                </template>
              </el-table-column>

              <!-- Usage -->
              <!-- <el-table-column class-name="centered-cell" :min-width="90" prop="usage" :label="$t('reports.usage')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.usage) }}
                </template>
              </el-table-column> -->

              <!-- Unit quantity -->
              <el-table-column class-name="centered-cell" :min-width="90" prop="netSold" :label="$t('reports.unitQty')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.netSold) }}
                </template>
              </el-table-column>

              <!-- Unit price -->
              <el-table-column class-name="centered-cell" :min-width="110" prop="unitPrice" :label="$t('reports.unitPrice')">
                <template slot-scope="props">
                  {{ props.row._isCategoryTotal ? '' : formatNumber(props.row.unitPrice) }}
                </template>
              </el-table-column>

              <!-- Sales -->
              <el-table-column class-name="centered-cell" :min-width="110" prop="sales" :label="$t('reports.sales')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.sales) }}
                </template>
              </el-table-column>

              <!-- Total discount -->
              <el-table-column class-name="centered-cell" :min-width="120" prop="totalDiscount" :label="$t('reports.discount')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.totalDiscount) }}
                </template>
              </el-table-column>

              <!-- Net sales -->
              <el-table-column class-name="centered-cell" :min-width="120" prop="netSales" :label="$t('reports.netSales')">
                <template slot-scope="props">
                  {{ formatNumber(props.row.netSales) }}
                </template>
              </el-table-column>
              </data-tables-server>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    GeneralTopBar,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard
  },
  props: {
    isMixedReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isMixedReport () {
      if (this.isMixedReport) {
        this.getOrders()
      }
    }
  },
  created () {
    this.getOrders()
    this.verifyUserLocations()
  },
  data () {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      loading: true,
      orders: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total',
        pageSize: 20,
        currentPage: 1,
        pageSizes: [20, 50, 100]
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      ordersTableData: {
        data: []
      },
      totalRecords: 0,
      totalAmount: 0,
      totalCounter: 0,
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      hasRceipt: null,
      colors: [
        '#f44336', // red
        '#2196f3', // blue
        '#ff9800', // orange
        '#9c27b0', // purple
        '#00bcd4', // cyan
        '#8bc34a', // light green
        '#ffc107', // amber
        '#3f51b5', // indigo
        '#ff5722', // deep orange
        '#795548', // brown
        '#607d8b', // blue grey
        '#009688', // teal
        '#cddc39', // lime
        '#673ab7', // deep purple
        '#03a9f4', // light blue
        '#aed581', // soft green
        '#ffb74d', // soft orange
        '#ba68c8'  // soft purple
      ],
      noData: false,
      tableOptions: {
        rowClassName: ({ row }) => {
          if (!row) return ''
          if (row._isGrandTotal) return 'mixed-grand-total-row'
          if (row._isCategoryHeader) return 'mixed-category-header-row'
          if (row._isCategoryTotal) return 'mixed-category-total-row'
          return ''
        }
      }
    }
  },
  methods: {
    changeValidFrom () {
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    getOrders (query) {
      if (!this.isMixedReport) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1

      this.apiRequest('/reports/v2/mixed-report' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, response => {
        if (response.status) {
          // Handle response structure: response.data is an array of items
          const rawItems = Array.isArray(response.data)
            ? response.data
            : (response.data.items || response.data.table_data || [])

          const groupedRows = []
          const categoryMap = {}

          // Helper to safely parse numbers
          const parseNumber = (value) => {
            const n = Number(value)
            return isNaN(n) ? 0 : n
          }

          // Separate products/options from category totals and grand total
          const categoryTotals = {}
          const grandTotalItems = []
          rawItems.forEach(item => {
            if (item.row_type === 'GRAND_TOTAL') {
              grandTotalItems.push(item)
            } else if (item.row_type === 'CATEGORY_TOTAL') {
              const catId = item.category_id || 'uncategorized'
              categoryTotals[catId] = item
            } else {
              const catId = item.category_id || 'uncategorized'
              if (!categoryMap[catId]) {
                categoryMap[catId] = {
                  category_id: catId,
                  category_name: item.category_name || this.$t('reports.uncategorized'),
                  products: []
                }
              }
              categoryMap[catId].products.push(item)
            }
          })

          // Build rows: category header, then product rows, then category totals (from API)
          Object.values(categoryMap).forEach(group => {
            // 1. Category header row (just category name, empty other columns)
            groupedRows.push({
              _isCategoryHeader: true,
              _isCategoryRow: true,
              category_id: group.category_id,
              category_name: group.category_name,
              id: '',
              name: group.category_name,
              sold: '',
              eatIn: '',
              takeOut: '',
              other: '',
              mixed: '',
              employee: '',
              refund: '',
              usage: '',
              unitQty: '',
              unitPrice: '',
              sales: '',
              totalDiscount: '',
              netSales: ''
            })

            // 2. Product rows (PRODUCT and OPTION types)
            group.products.forEach(item => {
              const sold = parseNumber(item.units_total)
              const netSold = parseNumber(item.net_units_total)
              const eatIn = parseNumber(item.units_other_delivery)
              const takeOut = parseNumber(item.units_pickup)
              const other = parseNumber(item.units_delivery)
              const employee = parseNumber(item.units_staff_food)
              const refund = parseNumber(item.units_refunded)
              const unitPrice = Number(item.unit_price || 0)
              const sales = Number(item.sales || 0)
              const totalDiscount = Number(item.total_discount || 0)
              const netSales = Number(item.net_sales || 0)
              const usage = sold * unitPrice

              groupedRows.push({
                _isCategoryHeader: false,
                _isCategoryRow: false,
                category_id: group.category_id,
                category_name: group.category_name,
                id: item.item_id,
                name: item.item_name,
                sold,
                netSold,
                eatIn,
                takeOut,
                other,
                mixed: 0,
                employee,
                refund,
                usage,
                unitQty: sold,
                unitPrice,
                sales,
                totalDiscount,
                netSales
              })
            })

            // 3. Category totals row (use the one from API if available)
            const apiTotal = categoryTotals[group.category_id]
            if (apiTotal) {
              const sold = parseNumber(apiTotal.units_total)
              const netSold = parseNumber(apiTotal.net_units_total)
              const eatIn = parseNumber(apiTotal.units_other_delivery)
              const takeOut = parseNumber(apiTotal.units_pickup)
              const other = parseNumber(apiTotal.units_delivery)
              const employee = parseNumber(apiTotal.units_staff_food)
              const refund = parseNumber(apiTotal.units_refunded)
              const unitPrice = Number(apiTotal.unit_price || 0)
              const sales = Number(apiTotal.sales || 0)
              const totalDiscount = Number(apiTotal.total_discount || 0)
              const netSales = Number(apiTotal.net_sales || 0)
              const usage = sold * unitPrice

              groupedRows.push({
                _isCategoryTotal: true,
                _isCategoryRow: true,
                category_id: group.category_id,
                category_name: group.category_name,
                id: '',
                name: group.category_name,
                sold,
                netSold,
                eatIn,
                takeOut,
                other,
                mixed: 0,
                employee,
                refund,
                usage,
                unitQty: sold,
                unitPrice: unitPrice || '',
                sales,
                totalDiscount,
                netSales
              })
            }
          })

          // 4. Grand total row — always last on the page
          grandTotalItems.forEach(item => {
            const sold = parseNumber(item.units_total)
            const netSold = parseNumber(item.net_units_total)
            const eatIn = parseNumber(item.units_other_delivery)
            const takeOut = parseNumber(item.units_pickup)
            const other = parseNumber(item.units_delivery)
            const employee = parseNumber(item.units_staff_food)
            const refund = parseNumber(item.units_refunded)
            const unitPrice = Number(item.unit_price || 0)
            const sales = Number(item.sales || 0)
            const totalDiscount = Number(item.total_discount || 0)
            const netSales = Number(item.net_sales || 0)
            const usage = sold * unitPrice

            groupedRows.push({
              _isGrandTotal: true,
              _isCategoryRow: true,
              id: '',
              name: this.$t('reports.grandTotal') || 'Grand Total',
              sold,
              netSold,
              eatIn,
              takeOut,
              other,
              mixed: 0,
              employee,
              refund,
              usage,
              unitQty: sold,
              unitPrice: unitPrice || '',
              sales,
              totalDiscount,
              netSales
            })
          })

          if (groupedRows && groupedRows.length) {
            this.noData = false
            this.ordersTableData.data = groupedRows
            this.ordersTableData.total = groupedRows.length
            // Note: totalRecords is based on expanded rows for current page, while server pagination is based on items
            this.totalRecords = response.pagination ? response.pagination.total : groupedRows.length
            this.paginationProps.currentPage = response.pagination ? response.pagination.page : page
            this.paginationProps.pageSize = response.pagination ? response.pagination.perPage : pageSize

            // Calculate totals from original items (exclude CATEGORY_TOTAL rows as they're already aggregated)
            this.totalCounter = response.pagination ? response.pagination.ordersTotal : 0
          } else {
            this.noData = true
            this.ordersTableData.data = []
            this.ordersTableData.total = 0
            this.totalRecords = 0
            this.paginationProps.currentPage = page
            this.paginationProps.pageSize = pageSize
          }
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    formatNumber (value) {
      if (value === '' || value === null || value === undefined) {
        return ''
      }
      const n = Number(value)
      if (!isFinite(n) || n === 0) {
        return n === 0 ? '0' : ''
      }
      return Number.isInteger(n) ? n : n.toFixed(2)
    },
    exportData () {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      // First, check if there is any data for the current filters.
      this.apiRequest('/reports/v2/mixed-report?page=1&per_page=1', 'GET', data, response => {
        if (response && response.status) {
          const pagination = response.pagination || {}
          const total = pagination.total != null ? pagination.total : 0

          if (!total) {
            // No data for current filters → show friendly message and skip download.
            swal(
              '',
              this.$t('reports.noData') || 'Nu există date',
              'info'
            )
            this.loading = false
            return
          }

          // There is data → proceed with download.
          this.apiRequest('/reports/v2/mixed-report-download', 'GET', data, downloadResponse => {
            if (downloadResponse && downloadResponse.status === true) {
              const link = document.createElement('a')
              link.href = downloadResponse.data.file
              link.setAttribute('download', downloadResponse.data.file_name)
              document.body.appendChild(link)
              link.click()
            } else {
              swal(
                '',
                this.$t('validations.wentWrong'),
                'error'
              )
            }
            this.loading = false
          })
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
          this.loading = false
        }
      })
    },
    paginationChanged (query) {
      this.getOrders(query)
    }
  }
}
</script>
<style>
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-container-compact {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 20px 30px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .report-container-compact .report-row {
    margin-bottom: 0;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  .report-container-compact .report-col:nth-child(1){
    font-size: 14px;
  }
  .report-container-compact .report-col:nth-child(2){
    font-size: 16px;
    font-weight: 600;
  }

  .centered-cell .cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mixed-category-header-row {
    background-color: #f0f0f0 !important;
    font-weight: 600;
  }
  .mixed-category-header-row .cell {
    font-weight: 600;
  }
  .mixed-category-total-row {
    background-color: #f0f0f0 !important;
    font-weight: 600;
  }
  .mixed-category-total-row .cell {
    font-weight: 600;
  }
  .mixed-grand-total-row {
    background-color: #d0e8ff !important;
    font-weight: 700;
  }
  .mixed-grand-total-row .cell {
    font-weight: 700;
  }
  .left-align-cell .cell {
    justify-content: flex-start;
  }
  .mixed-report-table-wrapper {
    overflow-x: visible;
    overflow-y: visible;
  }
  .mixed-table-scroll-container {
    overflow-x: auto;
    overflow-y: visible;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    position: relative;
  }
  .mixed-table-scroll-container .el-table {
    min-width: 1400px;
    width: 100%;
  }
  .mixed-table-scroll-container .el-table__header-wrapper,
  .mixed-table-scroll-container .el-table__body-wrapper {
    overflow-x: hidden;
  }
  .mixed-table-scroll-container .el-table__body-wrapper {
    max-height: 65vh;
    overflow-y: auto;
  }
  .mixed-table-scroll-container .el-table__header-wrapper {
    z-index: 10;
    background: #fff;
  }
  .mixed-table-scroll-container .el-table__header-wrapper th {
    background: #fff;
  }
  .mixed-table-scroll-container .el-table__header {
    width: 100% !important;
  }
  .mixed-table-scroll-container .el-table__body {
    width: 100% !important;
  }
  .mixed-report-table .el-table__header th:first-child,
  .mixed-report-table .el-table__body td:first-child {
    display: table-cell !important;
    visibility: visible !important;
  }
  .mixed-report-table .el-table__header th:nth-child(2),
  .mixed-report-table .el-table__body td:nth-child(2) {
    display: table-cell !important;
    visibility: visible !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/MixedReport.vue